import { gql } from '@apollo/client';
import NotificationMessageDTO from './fragments/notificationMessageDTO.fragment.notification';

export default gql`
  mutation markNotificationRead($uuid: String!) @client {
    markNotificationRead(input: { notificationUUID: $uuid }) {
      ...NotificationMessageDTO
    }
  }
  ${NotificationMessageDTO}
`;
